var Core = {
    Auth: {
        init: function () {
            $(".auth-component-login").focus();
            $(".auth-component-btn").click(function () {
                $(".auth-component-error").slideUp();
                $(".auth-component-success").slideUp();
                Core.Auth.checkCredentials();
            });

            $(".auth-component-login, .auth-component-passwd").keyup(function (e) {
                if (e.keyCode == 13 || e.charCode == 13) {
                    $(".auth-component-error").slideUp();
                    Core.Auth.checkCredentials();
                }
            });

            $(".auth-component-forgot").click(function () {
                $(".auth-component-error").slideUp();
                $(".main-login").addClass('main-hidden');
                $(".main-forgot").removeClass('main-hidden');
                $(".auth-component-forgot-login").focus();
                $(".auth-component-forgot-login").val('').removeAttr('disabled');
                $(".auth-component-forgot-email").val('').removeAttr('disabled');
                (<any>$(".auth-component-forgot-btn")).buttonLoader('stop');
            });

            $(".auth-component-forgot-back").click(function () {
                $(".auth-component-error").slideUp();
                $(".main-forgot").addClass('main-hidden');
                $(".main-forgot-code").addClass('main-hidden');
                $(".main-forgot-changepasswd").addClass('main-hidden');
                $(".main-login").removeClass('main-hidden');
                $(".auth-component-login").focus();
            });

            $(".auth-component-forgot-code").click(function () {
                $(".auth-component-error").slideUp();
                $(".main-forgot").addClass('main-hidden');
                $(".main-forgot-code").removeClass('main-hidden');
                $(".auth-component-forgot-token").focus();
            });

            $(".auth-component-forgot-login, .auth-component-forgot-email").keyup(function (e) {
                if (e.keyCode == 13 || e.charCode == 13) {
                    $(".auth-component-error").slideUp();
                    Core.Auth.ForgotPasswd();
                }
            });

            $(".auth-component-forgot-btn").click(function () {
                $(".auth-component-error").slideUp();
                Core.Auth.ForgotPasswd();
            });

            $("#btn-forgot-code").click(function () {
                $(".auth-component-error").slideUp();
                Core.Auth.ResetPasswd();
            });

            $(".auth-component-changepasswd-back").click(function () {
                grecaptcha.reset();
                $(".auth-component-error").slideUp();
                $(".main-changepasswd").addClass('main-hidden');
                $(".main-login").removeClass('main-hidden');
                $(".main-forgot").addClass('main-hidden');
                $(".main-forgot-code").addClass('main-hidden');
                $(".auth-component-login").focus();
            });

            $(".auth-component-changepasswd-showpass").click(function () {
                if (!$(this).attr('show')) {
                    $(".auth-component-error").slideUp();
                    $(".auth-component-newpasswd").attr('type', 'text');
                    $(this).html("<i class='mdi mdi-asterisk'></i> Esconder Senha");
                    $(this).attr('show', 1);
                } else {
                    $(".auth-component-error").slideUp();
                    $(".auth-component-newpasswd").attr('type', 'password');
                    $(this).html("<i class='mdi mdi-lock-open'></i> Mostrar Senha");
                    $(this).removeAttr('show');
                }
            });
        },

        checkCredentials: function () {
            var params = {
                'login': (<any>$(".auth-component-login").val()),
                'passwd': (<any>$(".auth-component-passwd").val()),
                'save': ($(".auth-component-save").is(':checked') ? 1 : 0),
                'env': $(".auth-component-btn").attr('env'),
                'captcha': grecaptcha.getResponse(),
            };

            if (params.login.length < 4) {
                $(".auth-component-login").focus();
                $(".auth-component-login-icon").css('color', 'red');
                return false;
            }

            if (params.passwd.length < 6) {
                $(".auth-component-passwd").focus();
                $(".auth-component-passwd-icon").css('color', 'red');
                return false;
            }

            Core.CallAuth('CheckCredentials', params, 'json', function () {
                (<any>$(".auth-component-btn")).buttonLoader('start');
            }, function (r: any) {
                if (r.response) {
                    if (r.response == true) {
                        Core.ReloadPage();
                    } else if (r.response.changepasswd == true) {
                        Core.Auth.ChangePasswd(r);
                    }
                } else {
                    grecaptcha.reset();
                    (<any>$(".auth-component-btn")).buttonLoader('stop');
                    $(".auth-component-error").html("<i class='mdi mdi-alert'></i> Dados não conferem!").slideDown();
                }
            });
        },

        ForgotPasswd: function () {
            var params = {
                'login': (<any>$(".auth-component-forgot-login")).val(),
                'email': (<any>$(".auth-component-forgot-email")).val(),
            };

            if (params.login.length > 4 || params.email.length > 5) {
                $(".auth-component-forgot-login").attr('disabled', 'disabled');
                $(".auth-component-forgot-email").attr('disabled', 'disabled');
                (<any>$(".auth-component-forgot-btn")).buttonLoader('start');

                Core.CallAuth('Forgot', params, 'json', null, function (r: any) {
                    if (r.response) {
                        $(".main-forgot").addClass('main-hidden');
                        $(".main-forgot-code").removeClass('main-hidden');
                        $(".auth-component-forgot-token").focus();
                    } else {
                        $(".auth-component-forgot-login").removeAttr('disabled');
                        $(".auth-component-forgot-email").removeAttr('disabled');
                        (<any>$(".auth-component-forgot-btn")).buttonLoader('stop');
                        $(".auth-component-error").html("<i class='mdi mdi-alert'></i> Usuário não encontrado!").slideDown();
                    }
                });
            } else {
                $(".auth-component-forgot-login").focus();
            }
        },

        ResetPasswd: function () {
            var params = {
                'token': (<any>$(".auth-component-forgot-token")).val(),
            };

            if (params.token.length == 6) {
                (<any>$(".auth-component-forgot-code-btn")).buttonLoader('start');
                Core.CallAuth('Reset', params, 'json', null, function (r: any) {
                    if (r.response && r.response.success && r.response.newpass) {
                        let html = `<i class='mdi mdi-checkbox-marked'></i> 
                                    Senha alterada com sucesso!
                                    <br/>
                                    Sua nova senha é: ${r.response.newpass}`;

                        (<any>$(".auth-component-forgot-code-btn")).buttonLoader('stop');
                        $(".auth-component-changepasswd-back").click();
                        $(".auth-component-success").html(html).slideDown();
                    } else {
                        (<any>$(".auth-component-forgot-code-btn")).buttonLoader('stop');
                        $(".auth-component-error").html("<i class='mdi mdi-alert'></i> Código inválido!").slideDown();
                    }
                });
            }
        },

        ChangePasswd: function (r: any) {
            $(".main-changepasswd").removeClass('main-hidden');
            $(".main-login").addClass('main-hidden');
            $(".auth-component-newpasswd").focus();
            (<any>$(".auth-component-btn")).buttonLoader('stop');

            $("#btn-changepasswd").unbind('click');
            $("#btn-changepasswd").click(function () {
                Core.Auth.TryChangePasswd(r.response);
            });
        },

        TryChangePasswd: function (r: any) {
            var pass1: any = $(".auth-component-newpasswd").val();
            if (pass1.length > 5) {
                var pass2 = $(".auth-component-newpasswd2").val();
                if (pass1 == pass2) {
                    (<any>$("#btn-changepasswd")).buttonLoader('start');
                    let params = {
                        'action': 'systemusuarios/try_update_password',
                        'user': r.user,
                        'newpasswd': pass1,
                        'save': ($(".auth-component-save").is(':checked') ? 1 : 0),
                    };

                    console.log(params);

                    Core.CallJSON(params, function (re: any) {
                        console.log(re);
                        if (re.response == true) {
                            $(".auth-component-newpasswd").val('');
                            $(".auth-component-newpasswd2").val('');
                            $(".auth-component-passwd").val('');
                            $(".auth-component-changepasswd-back").click();
                            $(".auth-component-login-alert").show();
                        } else if (re.error) {
                            (<any>$("#btn-changepasswd")).buttonLoader('stop');
                            $(".auth-component-error").html(re.error).slideDown();
                        }
                    })
                } else {
                    $(".auth-component-error").html("<i class='mdi mdi-alert'></i> Senhas devem ser iguais!").slideDown();
                }
            } else {
                $(".auth-component-error").html("<i class='mdi mdi-alert'></i> Mínimo 06 caracteres!").slideDown();
            }
        },

        Logout: function () {
            Core.CallAuth('Logout', null, 'json', null, function () {
                location.reload();
            });
        }
    },

    Actioner: {

        count: 0,

        init: function () {
            $(".actioner-component[fn]").each(function () {
                var fn = $(this).attr('fn');

                if (typeof fn !== 'undefined') {
                    $(this).removeAttr('fn');

                    var id = "actioner-" + Core.Actioner.count;
                    $(this).attr('id', id);

                    // Attach this
                    fn = fn.replace("({", "({aid:'" + id + "',");
                    $(this).click(function () {
                        eval(fn);
                    });

                    Core.Actioner.count++;
                }
            });
        }
    },

    CallAuth: function (fn: any, params: any, format: any, callinit: any, callback: any) {
        format = typeof format !== 'undefined' ? format : 'json'; // ACCEPT JSON || HTML

        var obj = {
            'fn': fn,
            'params': params,
            'format': format,
        };

        if (typeof callinit === 'function') {
            callinit();
        }

        $.post("/P5fw/auth", obj, function (r) {
            if (typeof callback == 'function') {
                callback(r);
            }
        }, format);
    },

    CallJSON: function (params: any, callback: any) {
        $.post("/P5fw/acmanager", params, function (r) {
            if (typeof callback === 'function') {
                callback(r);
            }
        }, 'json');
    },

    ReloadPage: function () {
        location.reload();
    },

    Serialize: function (obj: any) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
        return str.join("&");
    }
}

// -- INIT EVENT HANDLERS
$(() => {
    Core.Auth.init();
})